var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.29 12.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-current",
    d: "M5.7 1.46 3.36 3.82H.64a.64.64 0 0 0-.64.64v3.82a.64.64 0 0 0 .64.64h2.7l2.37 2.36a.64.64 0 0 0 1.09-.45V1.9a.64.64 0 0 0-1.1-.45ZM11.9.11a.64.64 0 0 0-.7 1.06 6.2 6.2 0 0 1 0 10.39.64.64 0 1 0 .7 1.07A7.49 7.49 0 0 0 11.9.1Zm.84 6.26a4.9 4.9 0 0 0-2.28-4.15.63.63 0 0 0-.88.2.65.65 0 0 0 .2.89 3.63 3.63 0 0 1 0 6.12.65.65 0 0 0-.2.89.64.64 0 0 0 .88.2 4.9 4.9 0 0 0 2.28-4.14ZM8.98 4.33a.64.64 0 1 0-.62 1.12 1.05 1.05 0 0 1 0 1.84.64.64 0 1 0 .62 1.12 2.32 2.32 0 0 0 0-4.08Z",
    "data-name": "Icon awesome-volume-up"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.b92f99fe3f7a1f7ac742c819a09756d0.svg";
export { ForwardRef as ReactComponent };